type Props = {
  onClick?: (provider: "google" | "apple") => void;
};

export default function SocialButtons({ onClick }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <button
        type="button"
        onClick={() => onClick?.("google")}
        className="flex items-center justify-center gap-2 px-4 py-3 rounded-full border border-background-300 text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap transition-colors cursor-pointer"
      >
        <i className="ri-google-fill text-base text-[#EA4335]"></i>
        Google
      </button>
      <button
        type="button"
        onClick={() => onClick?.("apple")}
        className="flex items-center justify-center gap-2 px-4 py-3 rounded-full border border-background-300 text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap transition-colors cursor-pointer"
      >
        <i className="ri-apple-fill text-base text-foreground-950"></i>
        Apple
      </button>
    </div>
  );
}